import React,{useRef, useEffect, useState} from 'react'
import Link from '../Classes/Link'
import Node from '../Classes/Node'
import {
    actionsState as projectState,
    actionsState as ProjectState
} from '../Redux/project'
import {connect, useDispatch, useSelector} from "react-redux";
import Modules from "./Modules";
import Projects from "./Projects";
import {Vector2} from "three";
import ModuleMenu from "./ModuleMenu";
import ModuleInfo from "./ModuleInfo";
import {
    getIntersection, getStrLang, is_touch_device,
    polyPoint
} from "../Helpers/functions";
import WallMenu from "./WallMenu";
import WallInfo from "./WallInfo";
import FloorMenu from "./FloorMenu";
import FloorInfo from "./FloorInfo";
import {sendRedrawEvent} from "../Helpers/Events";
import OrderMenu from "./OrderMenu";
import SaveInfo from "./SaveInfo";
import ModulesList from "./ModulesList";
import WallObjectInfo from "./WallObjectInfo";
import WallObjectMenu from "./WallObjectMenu";
import Materials from "./Materials";
import {put} from "redux-saga/effects";

let index = null;

const PlanEditor = (props)=>{
    const ref = useRef(null);
    const dispatch = useDispatch();
    const updateFlag = useSelector(store=>store.modules.updateModuleFlag);
    // console.log('TEST4',updateFlag);
    const [activeObject,setActiveObject] = useState(null);


    if (!window.projects) {
        const match = window.location.search.match(/(hash)=([A-Z0-9]{8})/);
        const match2 = window.location.search.match(/hash=new/);
        fetch("/ajax/configurator3d.php", {
            method: 'POST',
            body: JSON.stringify({method:"loadProjects"}),
            headers: {
                'Content-Type': 'application/json',
                'application':'x-www-form-urlencoded'
            }})
            .then(res => res.json())
            .then(
                (result) => {
                    // console.log('result',result)
                    if (result.status === 'ok') {
                        window.projects = result;
                        //3957BF66
                        if(!match && !match2){
                            dispatch(projectState.setModal('projects'));
                            // dispatch(projectState.decPreloader());
                        }
                        // dispatch(projectState.decPreloader())
                    } else {
                        // dispatch(projectState.decPreloader())
                    }
                },
                (error) => {
                    // dispatch(projectState.decPreloader())
                    console.log('error',error)
                }
            )
    }




    useEffect(()=>{

        // console.log('PlanEditor useEffect()')

        //стартует при монтаже компонента
        const canvas = ref.current;
        const ctx = canvas.getContext('2d');

        const {width, height} = canvas.getBoundingClientRect();

        const {devicePixelRatio: ratio=1} = window
        // const ratio = 1
        if (canvas.width !== width || canvas.height !== height) {
            canvas.width = ctx.width = width*ratio
            canvas.height = ctx.height = height*ratio
            ctx.scale(ratio, ratio)
        }

        const plan = props.plan;

        //стэйт для зума,таскания и состояния клика
        let offsetX = (canvas.width/2)-((canvas.width/2)/ratio);
        let offsetY = (canvas.height/2)-((canvas.height/2)/ratio);
        if (plan.ratio === ratio) {
            offsetX = plan.offsetX;
            offsetY = plan.offsetY;
        } else {
            plan.offsetX = offsetX
            plan.offsetY = offsetY
            plan.ratio = ratio
        }

        let zoom = 1;   // 0.2-40.0 в roomle
        let drag = false;   //флаг таскания плана
        let rotate = false;
        let hoverObject = null;
        let clickObject = null;
        let activeObject = null;
        let clickObjectPoint = null;
        let clickMousePoint = null;
        let startAngle = null;
        let startPosition = null;

        let touchPrevEvent = null;

        let A_pixel, B_pixel, A1_pixel, B1_pixel, _crossPoint

        if (plan.zoom !== zoom)
            zoom = plan.zoom
        else
            plan.zoom = zoom

        if (is_touch_device()) {
            zoom = .5
            plan.zoom = .5
        }
        // console.log('plan.zoom',plan.zoom)
///////////////////////////////////////////////////////////////////////////////
        const handlerKeydown = (event)=>{
            if(activeObject && activeObject.isModule) {
                let vPos
                if (event.code === 'ArrowUp') {
                    // console.log('activeObject.position',activeObject.position)
                    vPos = activeObject.position.clone()
                        .sub(new Vector2(
                            activeObject.position.x,
                            activeObject.position.y-1
                        )) //вектор перемещения

                    activeObject.position = {
                        x:activeObject.position.x-vPos.x,
                        y:activeObject.position.y-vPos.y
                    };

                    // console.log('activeObject.position',activeObject.position)
                } else if (event.code === 'ArrowDown') {
                    vPos = activeObject.position.clone()
                        .sub(new Vector2(
                            activeObject.position.x,
                            activeObject.position.y+1
                        )) //вектор перемещения

                    activeObject.position = {
                        x:activeObject.position.x-vPos.x,
                        y:activeObject.position.y-vPos.y
                    };
                } else if (event.code === 'ArrowLeft') {
                    vPos = activeObject.position.clone()
                        .sub(new Vector2(
                            activeObject.position.x-1,
                            activeObject.position.y
                        )) //вектор перемещения

                    activeObject.position = {
                        x:activeObject.position.x-vPos.x,
                        y:activeObject.position.y-vPos.y
                    };
                } else if (event.code === 'ArrowRight') {
                    vPos = activeObject.position.clone()
                        .sub(new Vector2(
                            activeObject.position.x+1,
                            activeObject.position.y
                        )) //вектор перемещения

                    activeObject.position = {
                        x:activeObject.position.x-vPos.x,
                        y:activeObject.position.y-vPos.y
                    };
                }
                // event.preventDefault();
                draw(ctx,plan);
            }

            if(activeObject && activeObject.type === 'node' && !activeObject.object.isLocked) {

                if (event.code === 'Delete') {
                    // removeNode(activeObject.object);
                } else if (event.code === 'ArrowUp') {
                    activeObject.object.y -= 1;
                    updatePlan();
                    draw(ctx,plan);
                } else if (event.code === 'ArrowDown') {
                    activeObject.object.y += 1;
                    updatePlan();
                    draw(ctx,plan);
                } else if (event.code === 'ArrowLeft') {
                    activeObject.object.x -= 1;
                    updatePlan();
                    draw(ctx,plan);
                } else if (event.code === 'ArrowRight') {
                    activeObject.object.x += 1;
                    updatePlan();
                    draw(ctx,plan);
                }

            }
        }
////////////////////////////////////////////////////////////////////////////////
        const handlerMove = (event)=>{
            // console.log('handlerMove',event)
            // console.log('handlerMove drag',drag)

            if (window.conf_nofunc || window.conf_noTouchFunc) {
                if(drag){
                    offsetX-=event.movementX;
                    offsetY-=event.movementY;

                    plan.offsetX = offsetX
                    plan.offsetY = offsetY
                    plan.canvasCenter = Convert.toSM(Convert.getCanvasCenterPixel())
                }
                draw(ctx,plan);
                return;
            }

            let point;
            if (event.type === 'touchmove' || event.type === 'touchstart'){
                if (event.changedTouches.length < 1)
                    return;
                point = Convert.toSM(new Node(event.changedTouches[0].clientX,event.changedTouches[0].clientY));
                // console.log('handlerMove point',point)

                if (!touchPrevEvent) touchPrevEvent = event;
            } else {
                point = Convert.toSM(new Node(event.clientX,event.clientY));
            }

            if(clickObject && clickObject.type !== 'node'){
                // console.log('clickMousePoint',clickMousePoint)
                // console.log('point',point)
                // console.log('startPosition',startPosition)
                if(activeObject && activeObject.isModule) {
                    const vPos = clickMousePoint.clone().sub(point) //вектор перемещения
                    if (startPosition === null) {
                        startPosition = clickObject.position.clone();
                    }
                    clickObject.position = {x:startPosition.x-vPos.x,y:startPosition.y-vPos.y};
                } else {
                    clickObject.position = point;
                }

                if (clickObject.wall && clickObject.obj > -1 && clickObjectPoint) {
                    const obj = clickObject.wall.objects[clickObject.obj]
                    let length = clickObject.wall.length() - obj.width - obj.pos


                    const vBase = obj.vector.clone().setLength(10000*zoom/2)
                    const A = obj.objA.clone()
                    const B = obj.objB.clone()
                    A.x = A.x - vBase.x
                    A.y = A.y - vBase.y
                    B.x = B.x + vBase.x
                    B.y = B.y + vBase.y

                    A_pixel = Convert.toPixel(A)
                    B_pixel = Convert.toPixel(B)

                    const vBase2 = vBase.clone().rotateAround(new Vector2(0,0), 90*(Math.PI/180))
                    const A1= obj.objA.clone()
                    const B1 = obj.objB.clone()
                    A1.x = point.x - vBase2.x
                    A1.y = point.y - vBase2.y
                    B1.x = point.x + vBase2.x
                    B1.y = point.y + vBase2.y

                    A1_pixel = Convert.toPixel(A1)
                    B1_pixel = Convert.toPixel(B1)

                    const crossPoint = getIntersection(
                        {x:A,y:B},
                        {x:A1,y:B1}
                    )
                    const crossPointV = new Vector2(crossPoint.x, crossPoint.y)
                    const distance = obj.objA.clone().distanceTo(crossPointV)


                    _crossPoint = Convert.toPixel(crossPoint)

                    const diffV = obj.objA.clone().sub(crossPointV)
                    if (diffV.angle().toFixed(2) === obj.vector.angle().toFixed(2))
                        obj.pos += distance
                    else
                        obj.pos -= distance
                    length = clickObject.wall.length() - obj.width - obj.pos
                    if (length < 0) obj.pos = clickObject.wall.length() - obj.width
                    if (obj.pos < 0) obj.pos = 0
                }

                draw(ctx,plan);
                return;
            }
            if(rotate){
                if(activeObject && activeObject.isModule){
                    activeObject.lookTo(point, clickMousePoint, startAngle);
                    draw(ctx,plan);
                }
            }
            plan.hoverNode = null;
            hoverObject = null;
            const [_distNode,_node] = getNearestDistToNode(point,plan.nodes);

            let _distLink = null;
            let _link=null;
            if(!_distNode<10/zoom){
                //отсеиваем Links принадлежащие Node которую тянем
                const exLinks = plan.dragNode?plan.links.filter(l=>l.a===plan.dragNode || l.a===plan.dragNode):[];
                const cortage = getNearestDistToLink(point,plan.links,exLinks);
                _distLink = cortage[0];
                _link = cortage[1];
            }

            if(_distNode<10/zoom){
                plan.hoverNode = _node;
            }


            if(plan.hoverNode === null){
                //hover module
                props.modules.map(m=>{
                    if(m.isHover(point)) hoverObject = m;
                });
                // hover wall
                if(hoverObject === null){
                    plan.links.map(l=>{
                        if(l.isHover(point)){
                            hoverObject = l;
                        }
                    })
                    // hover wall objects
                    if(hoverObject !== null){
                        for (let i=0; i < hoverObject.objects.length; i++) {
                            const obj = hoverObject.objects[i]
                            if (polyPoint(obj.points, point.x, point.y)) {
                                hoverObject = {'wall':hoverObject,'obj':i}
                                break
                            }
                        }
                    }
                }
                // hover floor
                if(hoverObject === null){
                    plan.loops.forEach((floor, index) => {
                        if (polyPoint(floor, point.x, point.y)) {
                            hoverObject = {'floor':index}
                        }
                    })
                }
            }

            if(plan.dragNode){
                const [_dist,_node] = plan.nodes.reduce((dn,n)=>{
                    if(n!==plan.dragNode){
                        const _d = distNodeToNode(point, n);
                        return _d<dn[0]?[_d,n]:dn;
                    }
                    else return dn;
                },[Infinity, null]);

                if(_dist<10/zoom){
                    plan.dragNode.copy(_node);
                    plan.hoverNode = _node;
                } else {

                    plan.nodes.find(node => {
                        const delta = 10
                        const diffX = Math.abs(node.x - point.x)
                        const diffY = Math.abs(node.y - point.y)
                        if (diffX <= delta) {
                            point.x = node.x
                            return
                        } else if (diffY <= delta) {
                            point.y = node.y
                            return
                        }
                    })

                    plan.dragNode.copy(point);
                }
                updatePlan(true)
            }
            else if(plan.virtualNode){

                const [_dist,_node] = plan.nodes.reduce((dn,n)=>{
                    if(n!==plan.dragNode){
                        const _d = distNodeToNode(point, n);
                        return _d<dn[0]?[_d,n]:dn;
                    }
                    else return dn;
                },[Infinity, null]);
                if(_dist<10/zoom){
                    plan.virtualNode.copy(_node);
                    plan.hoverNode = _node;
                } else {

                    /* Выравнивание по углу наклона
                    const vector = plan.virtualLink.a.clone().sub(point)
                    const vAngle = vector.angle()
                    const delta = .08

                    if (Math.abs(Math.PI - vAngle) <= delta) {
                        point.y = plan.virtualLink.a.y
                        plan.virtualLink.b.y = plan.virtualLink.a.y
                    } else if (Math.abs(3*Math.PI/2 - vAngle) <= delta) {
                        point.x = plan.virtualLink.a.x
                        plan.virtualLink.b.x = plan.virtualLink.a.x
                    } else if (Math.abs(2*Math.PI - vAngle) <= delta || vAngle <= delta) {
                        point.y = plan.virtualLink.a.y
                        plan.virtualLink.b.y = plan.virtualLink.a.y
                    } else if (Math.abs(Math.PI/2 - vAngle) <= delta) {
                        point.x = plan.virtualLink.a.x
                        plan.virtualLink.b.x = plan.virtualLink.a.x
                    }
                    */

                    plan.nodes.find(node => {
                        const delta = 10
                        const diffX = Math.abs(node.x - point.x)
                        const diffY = Math.abs(node.y - point.y)
                        if (diffX <= delta) {
                            point.x = node.x
                            return
                        } else if (diffY <= delta) {
                            point.y = node.y
                            return
                        }
                    })

                    plan.virtualNode.copy(point)
                }
                updatePlan(true)
            }
            else if(drag){

                if (event.type === 'touchmove'){

                    if (event.changedTouches.length > 0 && touchPrevEvent.changedTouches.length > 0){
                        offsetX -= (event.changedTouches[0].clientX - touchPrevEvent.changedTouches[0].clientX);
                        offsetY -= (event.changedTouches[0].clientY - touchPrevEvent.changedTouches[0].clientY);

                        plan.offsetX = offsetX
                        plan.offsetY = offsetY
                        plan.canvasCenter = Convert.toSM(Convert.getCanvasCenterPixel())
                    }

                    touchPrevEvent = event;

                } else {
                    offsetX-=event.movementX;
                    offsetY-=event.movementY;

                    plan.offsetX = offsetX
                    plan.offsetY = offsetY
                    plan.canvasCenter = Convert.toSM(Convert.getCanvasCenterPixel())
                }
            }
            draw(ctx,plan);
        };
////////////////////////////////////////////////////////////////////////////////
        const handlerDown = (event)=>{
            // console.log('handlerDown',event)
            // console.log('event.changedTouches.length',event.changedTouches.length)

            let point;
            if (event.type === 'touchstart'){
                if (event.changedTouches.length < 1)
                    return;

                // is not near edge of view, exit
                /*if (
                    (event.changedTouches[0].pageX > 10 && event.changedTouches[0].pageX < window.innerWidth - 10) &&
                    (event.changedTouches[0].pageY > 10 && event.changedTouches[0].pageY < window.innerHeight - 10)
                ) {

                }else{
                    return;
                }*/

                point = Convert.toSM(new Node(event.changedTouches[0].clientX,event.changedTouches[0].clientY));
                // console.log('handlerDown point',point)
                // console.log('handlerDown',event)

            } else {
                point = Convert.toSM(new Node(event.clientX,event.clientY));
            }
            clickMousePoint = point;

            clickObject = null
            clickObjectPoint = null
            // clickMousePoint = null
            startAngle = null
            startPosition = null
            touchPrevEvent = null

            if (window.conf_nofunc || window.conf_noTouchFunc) {
                drag = true;
                return;
            }

            let click_node = null;
            let click_link = null;
            //let click_object = null;
            if(activeObject && activeObject.isModule){
                if(activeObject.isHoverRotateControl(point)){
                    startAngle = activeObject.angle
                    rotate=true;
                    return;
                }
            }

            const [_dist,_node] = plan.nodes.reduce((dn,n)=>{
                const _d = distNodeToNode(point, n);
                return _d<dn[0]?[_d,n]:dn;
            },[Infinity, null]);

            if(_dist < 10) click_node = _node;

            if(!click_node){
                const [_dist,_link] = plan.links.reduce((dl,l)=>{
                    const _d = distNodeToLink(point, l);
                    return _d<dl[0]?[_d,l]:dl;
                },[Infinity, null]);
                if (_link &&_dist < _link.h/2) {
                    click_link = _link;
                }
            }

            if(!props.editMode){
                if(click_node){
                    plan.dragNode = click_node;
                    clickObject = {
                        type:'node',
                        object:click_node,
                    };
                }
                else{
                    props.modules.map(m=>{
                        if(m.isHover(point)) clickObject = m;
                    });
                    if(!clickObject){
                        plan.links.map(l=>{
                            if(l.isHover(point)) clickObject = l;
                        });
                        // click wall objects
                        if(clickObject){
                            for (let i=0; i < clickObject.objects.length; i++) {
                                const obj = clickObject.objects[i]
                                if (polyPoint(obj.points, point.x, point.y)) {
                                    const l = clickObject
                                    clickObject = obj
                                    clickObject.wall = l
                                    clickObject.obj = i
                                    clickObjectPoint = point.clone()
                                    break
                                }
                            }
                        }
                    }
                    if(!clickObject){
                        plan.loops.forEach((floor, index) => {
                            if (polyPoint(floor, point.x, point.y) && plan.cycles[index]) {
                                clickObject = plan.cycles[index]
                                clickObject.floor = index
                            }
                        })
                    }
                    if(clickObject) {
                        // setActiveObject(null)
                        // dispatch(projectState.setModal(''));
                        _setActiveObject({
                            point,
                            object:clickObject
                        })
                    } else {
                        drag = true;
                    }
                }

            }
            else {


                // если рисуем план и попадаем в ноду, соединяем и отключаем редактирование
                if(click_node){

                    if (event.type === 'touchstart' && plan.virtualLink) {
                        plan.virtualLink.b.x = point.x
                        plan.virtualLink.b.y = point.y
                        // plan.virtualNode.x = point.x
                        // plan.virtualNode.y = point.y
                    }

                    if(plan.virtualNode){
                        const vNode = plan.virtualNode
                        plan.putNode(vNode)
                        plan.mergeNode(vNode,click_node)
                    }

                    if (event.button === 2) {
                        plan.virtualNode = null
                        plan.virtualLink = null
                        dispatch(ProjectState.setEditMode(false))
                    } else {
                        plan.virtualNode = new Node(point.x,point.y);
                        plan.virtualLink = new Link(click_node,plan.virtualNode);
                    }
                }
                else if(click_link){

                    const weight = point.clone().sub(click_link.a).length()/click_link.b.clone().sub(click_link.a).length();
                    // console.log("CLICK LINK ",click_link,weight);

                    plan.cutWall(click_link,weight);
                    if(plan.virtualNode){
                        //plan.virtualNode = click_link.b;


                        // console.log('if(click_link){ plan.virtualNode', plan.virtualNode)
                        // console.log('if(click_link){ click_link', click_link)

                        if (event.type === 'touchstart' && plan.virtualLink) {
                            plan.virtualLink.b.x = point.x
                            plan.virtualLink.b.y = point.y
                        }

                        const node = plan.virtualNode;
                        plan.putNode(node);
                        plan.mergeNode(node,click_link.b);
                        plan.virtualNode = null;
                        plan.virtualLink = null;
                        dispatch(ProjectState.setEditMode(false));
                    }
                    else{
                        plan.virtualNode = new Node(point.x,point.y);
                        plan.virtualLink = new Link(click_link.b,plan.virtualNode);
                    }
                }
                else {
                    if (event.button === 2) {
                        plan.virtualNode = null
                        plan.virtualLink = null
                        dispatch(ProjectState.setEditMode(false))
                        plan.calcGraphLoop(true)
                    } else {
                        if (event.type === 'touchstart'){
                            if (plan.virtualLink) {
                                plan.virtualLink.b.x = point.x
                                plan.virtualLink.b.y = point.y
                            }
                            plan.putNode(plan.virtualNode?plan.virtualNode:new Node(point.x,point.y));
                            // handlerMove(event)
                        } else {
                            plan.putNode(plan.virtualNode?plan.virtualNode:new Node(point.x,point.y));
                        }
                    }
                }
                setActiveObject(null)
            }
            if(activeObject && activeObject.isModule) {
                startPosition = activeObject.position.clone();
            }
            draw(ctx,plan);

            // console.log('plan.nodes',plan.nodes)
            // console.log('plan.links',plan.links)
            // console.log('handlerDown plan.virtualNode',plan.virtualNode)
            // console.log('handlerDown plan.virtualLink',plan.virtualLink)
        };
////////////////////////////////////////////////////////////////////////
        const handlerUp = (event)=>{
            // console.log('handlerUp',event)

            let point;
            if (event.type === 'touchend'){
                if (event.changedTouches.length < 1)
                    return;
                point = Convert.toSM(new Node(event.changedTouches[0].clientX,event.changedTouches[0].clientY));
                // console.log('handlerUp point',point)
            } else {
                point = Convert.toSM(new Node(event.clientX,event.clientY));
            }

            dispatch(projectState.addPreloader())

            if (clickObject && clickObject.type === 'node') {
                _setActiveObject({
                    point,
                    object:clickObject
                })
            }

            clickObjectPoint = null
            clickMousePoint = null
            startAngle = null
            startPosition = null
            touchPrevEvent = null

            drag = false;
            rotate = false;
            clickObject = null;
            if(plan.dragNode){

                const [_dist,_node] = plan.nodes.reduce((dn,n)=>{
                    if(n!==plan.dragNode){
                        const _d = distNodeToNode(point, n);
                        return _d<dn[0]?[_d,n]:dn;
                    }
                    else return dn;
                },[Infinity, null]);

                if(_dist<10/zoom){
                    plan.mergeNode(plan.dragNode,_node);
                } else {
                    plan.nodes.find(node => {
                        const delta = 10
                        const diffX = Math.abs(node.x - point.x)
                        const diffY = Math.abs(node.y - point.y)
                        if (diffX <= delta) {
                            point.x = node.x
                            return
                        } else if (diffY <= delta) {
                            point.y = node.y
                            return
                        }
                    })

                    plan.dragNode.copy(point);
                }
                plan.dragNode = null;

                updatePlan()
                draw(ctx,plan);
            }
            if(plan.virtualNode){
                // const [_dist,_node] = plan.nodes.reduce((dn,n)=>{
                //     if(n!==plan.dragNode){
                //         const _d = distNodeToNode(point, n);
                //         return _d<dn[0]?[_d,n]:dn;
                //     }
                //     else return dn;
                // },[Infinity, null]);
                //
                // if(_dist<10){
                //     plan.links.push(new Link(plan.virtualLink.a,_node))
                //     plan.mergeNode(plan.dragNode,_node);
                //     plan.virtualLink = null;
                //     plan.virtualNode = null;
                // }

                updatePlan()
                draw(ctx,plan);
            }

            // console.log('plan.nodes',plan.nodes)
            dispatch(projectState.decPreloader())
        };
////////////////////////////////////////////////////////////////////////////////
        const handlerContext = (e)=>{
            e.preventDefault();
            return false;
        };
////////////////////////////////////////////////////////////////////////////////
        const handlerRedraw = (e)=>{
            e.preventDefault();
            updatePlan()
            draw(ctx,plan);
            return false;
        };
        const handlerRedrawSimple = (e)=>{
            e.preventDefault();
            draw(ctx,plan);
            return false;
        };
////////////////////////////////////////////////////////////////////////////////
        const handlerUnselect = (e)=>{
            e.preventDefault();
            hoverObject = null
            activeObject = null
            setActiveObject(null)

            drag = false;
            rotate = false;
            clickObject = null;
            plan.virtualNode = null
            plan.virtualLink = null

            updatePlan()
            draw(ctx,plan);
            return false;
        };
////////////////////////////////////////////////////////////////////////////////
        const handlerReselect= (e)=>{
            e.preventDefault();
            const __activeObject = activeObject
            // console.log('__activeObject',__activeObject)
            setActiveObject(null)
            setActiveObject({point:{},object:__activeObject})
            updatePlan()
            draw(ctx,plan);
            return false;
        };
///////////////////////////////////////////////////////////////////////////////
        const handlerWheel = (e)=>{
            zoom -= e.deltaY/2000;
            if(zoom>40) zoom = 40;
            if(zoom<0.2) zoom = 0.2;
            plan.zoom = zoom
            // updatePlan()
            draw(ctx,plan);
            e.preventDefault();
        };
///////////////////////////////////////////////////////////////////////////////
        const handlerOnselectstart = (e)=>{
            return false;
        };
///////////////////////////////////////////////////////////////////////////////
        const handlerOut = ()=>{
            // console.log('handlerOut')
            drag = false;
            rotate = false;
            clickObject = null;
            // if(plan.virtualNode){
            //     plan.putNode(plan.virtualNode);
            //     plan.virtualNode = null;
            //     plan.virtualLink = null;
            //     draw(ctx,plan);
            // }
        };
        const handlerResize = ()=>{
            const {width, height} = canvas.getBoundingClientRect();

            const {devicePixelRatio: ratio=1} = window
            if (canvas.width !== width || canvas.height !== height) {
                canvas.width = ctx.width = width*ratio
                canvas.height = ctx.height = height*ratio
                ctx.scale(ratio, ratio)
            }
            offsetX = (canvas.width/ratio)/2;
            offsetY = (canvas.height/ratio)/2;

            plan.offsetX = offsetX
            plan.offsetY = offsetY
            plan.canvasCenter = Convert.toSM(Convert.getCanvasCenterPixel())
            // updatePlan()
            draw(ctx,plan);
        }
///////////////////////////////////////////////////////////////////////////////////
        const _setActiveObject = (obj)=>{
            setActiveObject(obj);
            activeObject = obj.object;
        }
//////////////////////////////////////////////////////////////////////////
        const updatePlan = (wallsOnly = false)=>{
            plan.calcGraphLoop(true, wallsOnly)
        }
        const draw = (ctx,plan)=>{

            // let start, end
            // start = new Date().getTime()

            // console.log('offsetX,offsetY',offsetX,offsetY)

            ctx.fillStyle = '#EEEEEE';
            ctx.strokeStyle = '#000000';
            ctx.font='12px Arial';
            ctx.textBaseline = 'middle';
            ctx.textAlign = 'center';
            ctx.fillRect(0,0,ctx.width,ctx.height);
            if (window.grid) drawGrid();

            // if (!window.debug)
                drawFloor(plan);

            ctx.fillStyle = '#000000';
            drawWalls(plan)

            // if (window.debug) drawFloor(plan);

            plan.nodes.map(n=>{
                drawNode(plan,n);
            });
            if(plan.virtualNode) drawNode(plan,plan.virtualNode);

            props.modules.map(m=>drawModule(m));

            // end = new Date().getTime()
            // console.log('draw(): '+(end-start)+'ms')



            /*if (A_pixel && B_pixel) {
                ctx.strokeStyle = '#2dcb4f'
                ctx.beginPath()
                ctx.moveTo(A_pixel.x,A_pixel.y)
                ctx.lineTo(B_pixel.x,B_pixel.y)
                ctx.closePath()
                ctx.stroke()
            }
            if (A1_pixel && B1_pixel) {
                ctx.strokeStyle = '#ee4b4b'
                ctx.beginPath()
                ctx.moveTo(A1_pixel.x,A1_pixel.y)
                ctx.lineTo(B1_pixel.x,B1_pixel.y)
                ctx.closePath()
                ctx.stroke()
            }
            if (_crossPoint) {

                ctx.fillStyle = 'rgba(255,255,255,0.5)';
                ctx.strokeStyle = 'rgba(0,0,0,0.5)';
                const r = 2;
                ctx.beginPath();
                ctx.arc(_crossPoint.x, _crossPoint.y, r, 0, 2 * Math.PI);
                ctx.fill();
                ctx.stroke();
            }*/

            /*
            const canvasCenter = Convert.getCanvasCenterPixel()
            ctx.fillStyle = 'rgba(255,255,255)';
            ctx.strokeStyle = 'rgb(255,0,0)';
            const r = 2;
            ctx.beginPath();
            ctx.arc(canvasCenter.x, canvasCenter.y, r, 0, 2 * Math.PI);
            ctx.fill();
            ctx.stroke();
             */
        };
///////////////////////////////////////////////////////////////////////////////
        const drawGrid = () => {

            const center = Convert.toPixel(new Node(0,0));

            // console.log('zoom',zoom)

            //const startX = Math.ceil(center.x/10/zoom);
            // const ceilX = Math.ceil(ctx.width/(10*zoom));
            // const ceilY = Math.ceil(ctx.height/(10*zoom));
            // const iter = Math.max(ceilX,ceilY);
            // if (zoom > .6) {
            //     for(let i=1;i<iter;i++){
            //         ctx.strokeStyle = '#e9e9e9';
            //         ctx.beginPath();
            //         ctx.moveTo(center.x-i*10*zoom,0);
            //         ctx.lineTo(center.x-i*10*zoom,ctx.height);
            //         ctx.moveTo(center.x+i*10*zoom,0);
            //         ctx.lineTo(center.x+i*10*zoom,ctx.height);
            //         ctx.moveTo(0,center.y-i*10*zoom);
            //         ctx.lineTo(ctx.width,center.y-i*10*zoom);
            //         ctx.moveTo(0,center.y+i*10*zoom);
            //         ctx.lineTo(ctx.width,center.y+i*10*zoom);
            //         ctx.stroke();
            //     }
            // }
            // for(let i=1;i<iter;i++){
            //     if(i%10 === 0 ) {
            //         ctx.strokeStyle = '#d0d0d0';
            //         ctx.beginPath();
            //         ctx.moveTo(center.x-i*10*zoom,0);
            //         ctx.lineTo(center.x-i*10*zoom,ctx.height);
            //         ctx.moveTo(center.x+i*10*zoom,0);
            //         ctx.lineTo(center.x+i*10*zoom,ctx.height);
            //         ctx.moveTo(0,center.y-i*10*zoom);
            //         ctx.lineTo(ctx.width,center.y-i*10*zoom);
            //         ctx.moveTo(0,center.y+i*10*zoom);
            //         ctx.lineTo(ctx.width,center.y+i*10*zoom);
            //         ctx.stroke();
            //     }
            // }
            ctx.strokeStyle = '#343434';
            ctx.beginPath();
            ctx.moveTo(center.x,0);
            ctx.lineTo(center.x,ctx.height);
            ctx.moveTo(0,center.y);
            ctx.lineTo(ctx.width,center.y);
            ctx.stroke();
        }
///////////////////////////////////////////////////////////////////////////////
        const drawFloor = (plan) => {
            // console.log('drawFloor()=>plan.cycles',plan.cycles)
            /*plan.loopsDebug.forEach((floor, index) => {
                ctx.strokeStyle = '#ff3535'
                let first = true
                floor.forEach(node => {
                    const point = Convert.toPixel(node)
                    if (first) {
                        first = false
                        ctx.beginPath()
                        ctx.moveTo(point.x, point.y)
                    } else {
                        ctx.lineTo(point.x, point.y)
                    }
                })
                ctx.closePath()
                ctx.stroke()
            })*/
            plan.loops.forEach((floor, index) => {

                // console.log('plan.cycles[index].material.userData.IMAGE',plan.cycles[index].material.userData.IMAGE)


                if (floor.square > 0) {

                    /*
                    const imgUrl = plan.cycles[index].material.userData.IMAGE
                    // const imgUrl = window.materials.floor[0].userData.IMAGE
                    // const material = window.materials.floor.find(m=>m.userData.ID===floor.materialID)
                    // const imgUrl = material.userData.IMAGE

                    let bgImage = -1
                    const img_id = loadedImagesURLs.indexOf(imgUrl)
                    if (img_id === -1) {
                        loadImage(imgUrl)
                    } else if (isQueueImagesEmpty()) {
                        ctxFake2.clearRect(0, 0, canvasFake2.width, canvasFake2.height)
                        bgImage = loadedImages[img_id]
                        const wCount = Math.ceil(ctxFake2.width/(bgImage.width*zoom))
                        const hCount = Math.ceil(ctxFake2.height/(bgImage.height*zoom))
                        for (let i = 0; i <= wCount; i++) {
                            for (let j = 0; j <= hCount; j++) {
                                const x = i * bgImage.width/ratio*zoom
                                const y = j * bgImage.height/ratio*zoom
                                ctxFake2.drawImage(bgImage, x, y, bgImage.width/ratio*zoom, bgImage.height/ratio*zoom)
                            }
                        }

                        ctxFake.clearRect(0, 0, canvasFake.width, canvasFake.height)
                        ctxFake.save()
                        ctxFake.fillStyle = '#f00'
                        ctxFake.strokeStyle = '#f00'
                        let first = true
                        floor.forEach(node => {
                            const point = Convert.toPixel(node)
                            if (first) {
                                first = false
                                ctxFake.beginPath()
                                ctxFake.moveTo(point.x, point.y)
                            } else {
                                ctxFake.lineTo(point.x, point.y)
                            }
                        })
                        ctxFake.closePath()
                        ctxFake.stroke()
                        ctxFake.fill()

                        ctxFake.globalCompositeOperation = "source-in"

                        ctxFake.drawImage(canvasFake2, 0, 0)

                        ctxFake.restore()
                        ctx.globalCompositeOperation = "source-over"
                        ctx.drawImage(canvasFake, 0, 0, canvasFake.width/ratio, canvasFake.height/ratio)
                    }
                    */

                    if (floor.bgImage && floor.bgImage.src && floor.bgImage.src.includes('data:image/png;base64')) {
                        const point = Convert.toPixel(new Node(floor.texRect.x, floor.texRect.y))

                        // console.log('floor.bgImage.src',floor.bgImage.src)

                        // ctx.fillStyle = '#f0e3d350'
                        // ctx.rect(point.x, point.y, floor.texRect.w*zoom, floor.texRect.h*zoom)
                        // ctx.fill();
                        ctx.drawImage(floor.bgImage, point.x, point.y, floor.texRect.w*zoom, floor.texRect.h*zoom)
                    } else {
                        // console.log('floor.bgImage',floor.bgImage)
                    }

                    if (window.debug) {
                        ctx.fillStyle = '#f0e3d350'
                        ctx.strokeStyle = '#ff3535'
                    } else {
                        ctx.fillStyle = '#f0e3d3'
                        ctx.strokeStyle = '#f0e3d3'
                    }

                    if (hoverObject && hoverObject.floor === index) {
                        ctx.strokeStyle = ctx.fillStyle = '#009ee350'

                        let first = true
                        floor.forEach(node => {
                            const point = Convert.toPixel(node)
                            if (first) {
                                first = false
                                ctx.beginPath()
                                ctx.moveTo(point.x, point.y)
                            } else {
                                ctx.lineTo(point.x, point.y)
                            }
                        })
                        ctx.closePath()
                        ctx.stroke()
                        ctx.fill()
                    }
                    if (activeObject && activeObject.floor === index) {
                        ctx.strokeStyle = ctx.fillStyle = '#009ee380'
                        ctx.lineWidth = 30*zoom

                        let first = true
                        floor.forEach(node => {
                            const point = Convert.toPixel(node)
                            if (first) {
                                first = false
                                ctx.beginPath()
                                ctx.moveTo(point.x, point.y)
                            } else {
                                ctx.lineTo(point.x, point.y)
                            }
                        })
                        ctx.closePath()
                        ctx.stroke()
                        ctx.lineWidth = 1
                    }



                    ctx.fillStyle = '#000000'
                    const diagonalCenterPixel = Convert.toPixel(floor.diagonalCenter)
                    ctx.fillText(floor.squareText, diagonalCenterPixel.x, diagonalCenterPixel.y-4)
                }
            })

        }
/////////////////////////////////////////////////////////////////////////////////////
        const drawWalls = (plan) => {

            // console.log('plan.walls',plan.walls)

            plan.walls.map((wall, index) => {
                const _a = Convert.toPixel(wall.a)
                const _b = Convert.toPixel(wall.b)

                // ctx.fillStyle = ctx.strokeStyle = '#868786'
                // ctx.beginPath()
                // ctx.moveTo(_a.x,_a.y)
                // ctx.lineTo(_b.x,_b.y)
                // ctx.closePath()
                // ctx.stroke()


                /* Debug *
                const grA1_pixel = Convert.toPixel(wall.grA1)
                const grA2_pixel = Convert.toPixel(wall.grA2)
                const grB1_pixel = Convert.toPixel(wall.grB1)
                const grB2_pixel = Convert.toPixel(wall.grB2)

                ctx.strokeStyle = '#9dee4b'
                ctx.beginPath()
                ctx.moveTo(grA1_pixel.x,grA1_pixel.y)
                ctx.lineTo(grB1_pixel.x,grB1_pixel.y)
                ctx.closePath()
                ctx.stroke()

                ctx.strokeStyle = '#ee854b'
                ctx.beginPath()
                ctx.moveTo(grA2_pixel.x,grA2_pixel.y)
                ctx.lineTo(grB2_pixel.x,grB2_pixel.y)
                ctx.closePath()
                ctx.stroke()
                * / Debug */


                const rA1_pixel = Convert.toPixel(wall.rA1)
                const rA2_pixel = Convert.toPixel(wall.rA2)
                const rB1_pixel = Convert.toPixel(wall.rB1)
                const rB2_pixel = Convert.toPixel(wall.rB2)

                // ctx.fillStyle = '#868786'
                ctx.fillStyle = '#000000'
                if (window.debug) ctx.fillStyle = 'rgba(134,135,134,0.3)'
                // ctx.strokeStyle = '#868786'
                ctx.strokeStyle = '#000000'
                // ctx.fillStyle = ctx.strokeStyle = wall.color

                ctx.beginPath()
                ctx.moveTo(rA1_pixel.x,rA1_pixel.y)
                ctx.lineTo(_a.x,_a.y) // node center point
                ctx.lineTo(rB1_pixel.x,rB1_pixel.y)
                ctx.lineTo(rB2_pixel.x,rB2_pixel.y)
                ctx.lineTo(_b.x,_b.y) // node center point
                ctx.lineTo(rA2_pixel.x,rA2_pixel.y)
                ctx.lineTo(rA1_pixel.x,rA1_pixel.y)
                ctx.closePath()
                ctx.stroke()

                if(
                    (hoverObject && hoverObject.a === wall.a && hoverObject.b === wall.b) ||
                    (activeObject && activeObject.a === wall.a && activeObject.b === wall.b)
                ){
                    ctx.strokeStyle = ctx.fillStyle = '#009ee3'
                }
                ctx.fill()

                drawSize(plan,wall)
            })
            plan.walls.map((wall, index) => {
                const _a = Convert.toPixel(wall.a)
                const _b = Convert.toPixel(wall.b)

                wall.objects.map((obj, objIndex) => {

                    const v = wall.a.clone().sub(wall.b) //вектор стены
                    const c = _b.clone().add(_a).multiplyScalar(0.5)
                    const halfH = wall.h/2

                    const objA = wall.a.clone().add(v.clone().setLength(obj.pos).negate())
                    const objB = objA.clone().add(v.clone().setLength(obj.width).negate())
                    const objV = objA.clone().sub(objB) //вектор объекта
                    obj.vector = objV
                    obj.objA = objA
                    obj.objB = objB

                    const __v = objV.clone().rotateAround(new Vector2(0,0), 90*(Math.PI/180)).setLength(halfH)
                    obj.rA1 = {x:__v.x+objA.x,y:__v.y+objA.y}
                    obj.rB1 = {x:__v.x+objB.x,y:__v.y+objB.y}

                    const __v2 = objV.clone().rotateAround(new Vector2(0,0), -90*(Math.PI/180)).setLength(halfH)
                    obj.rA2 = {x:__v2.x+objA.x,y:__v2.y+objA.y}
                    obj.rB2 = {x:__v2.x+objB.x,y:__v2.y+objB.y}

                    const pointA = {x:objA.x, y:objA.y}
                    const pointB = {x:objB.x, y:objB.y}

                    const _pointA = Convert.toPixel(pointA)
                    const _pointB = Convert.toPixel(pointB)

                    const grA1_pixel = Convert.toPixel(obj.rA1)
                    const grA2_pixel = Convert.toPixel(obj.rA2)
                    const grB1_pixel = Convert.toPixel(obj.rB1)
                    const grB2_pixel = Convert.toPixel(obj.rB2)

                    // obj.points = [grA1_pixel.clone(),grA2_pixel.clone(),grB2_pixel.clone(),grB1_pixel.clone()]
                    obj.points = [obj.rA1,obj.rA2,obj.rB2,obj.rB1]

                    ctx.fillStyle = '#fff'
                    ctx.strokeStyle = '#868786'

                    if(
                        (hoverObject && hoverObject.wall && hoverObject.wall.a === wall.a && hoverObject.wall.b === wall.b && objIndex === hoverObject.obj) ||
                        (activeObject && activeObject.wall && activeObject.wall.a === wall.a && activeObject.wall.b === wall.b && objIndex === activeObject.obj)
                    ){
                        ctx.fillStyle = '#009ee3'
                        ctx.strokeStyle = '#fff'
                    }

                    ctx.beginPath()
                    ctx.moveTo(grA1_pixel.x,grA1_pixel.y)
                    ctx.lineTo(grA2_pixel.x,grA2_pixel.y)
                    ctx.lineTo(grB2_pixel.x,grB2_pixel.y)
                    ctx.lineTo(grB1_pixel.x,grB1_pixel.y)
                    ctx.moveTo(grA1_pixel.x,grA1_pixel.y)
                    ctx.closePath()
                    ctx.fill()
                    ctx.stroke()


                    if (obj.isWindow) {
                        const __v3 = objV.clone().rotateAround(new Vector2(0,0), 90*(Math.PI/180)).setLength(halfH/3)
                        obj.rA11 = {x:__v3.x+objA.x,y:__v3.y+objA.y}
                        obj.rB11 = {x:__v3.x+objB.x,y:__v3.y+objB.y}

                        const __v4 = objV.clone().rotateAround(new Vector2(0,0), -90*(Math.PI/180)).setLength(halfH/3)
                        obj.rA22 = {x:__v4.x+objA.x,y:__v4.y+objA.y}
                        obj.rB22 = {x:__v4.x+objB.x,y:__v4.y+objB.y}

                        const grA11_pixel = Convert.toPixel(obj.rA11)
                        const grA22_pixel = Convert.toPixel(obj.rA22)
                        const grB11_pixel = Convert.toPixel(obj.rB11)
                        const grB22_pixel = Convert.toPixel(obj.rB22)

                        ctx.beginPath()
                        ctx.moveTo(grA11_pixel.x,grA11_pixel.y)
                        ctx.lineTo(grB11_pixel.x,grB11_pixel.y)
                        ctx.closePath()
                        ctx.stroke()

                        ctx.beginPath()
                        ctx.moveTo(grA22_pixel.x,grA22_pixel.y)
                        ctx.lineTo(grB22_pixel.x,grB22_pixel.y)
                        ctx.closePath()
                        ctx.stroke()
                    }
                })

                // Повторно для того, чтобы ховер элементы были сверху
                wall.objects.map((obj, objIndex) => {
                    if(hoverObject && hoverObject.wall && hoverObject.wall.a === wall.a && hoverObject.wall.b === wall.b && objIndex === hoverObject.obj){

                        const v = wall.a.clone().sub(wall.b) //вектор стены
                        const halfH = wall.h/2

                        const objA = wall.a.clone().add(v.clone().setLength(obj.pos).negate())
                        const objB = objA.clone().add(v.clone().setLength(obj.width).negate())
                        const objV = objA.clone().sub(objB) //вектор объекта
                        obj.vector = objV
                        obj.objA = objA
                        obj.objB = objB

                        const __v = objV.clone().rotateAround(new Vector2(0,0), 90*(Math.PI/180)).setLength(halfH)
                        obj.rA1 = {x:__v.x+objA.x,y:__v.y+objA.y}
                        obj.rB1 = {x:__v.x+objB.x,y:__v.y+objB.y}

                        const __v2 = objV.clone().rotateAround(new Vector2(0,0), -90*(Math.PI/180)).setLength(halfH)
                        obj.rA2 = {x:__v2.x+objA.x,y:__v2.y+objA.y}
                        obj.rB2 = {x:__v2.x+objB.x,y:__v2.y+objB.y}

                        const pointA = {x:objA.x, y:objA.y}
                        const pointB = {x:objB.x, y:objB.y}

                        const grA1_pixel = Convert.toPixel(obj.rA1)
                        const grA2_pixel = Convert.toPixel(obj.rA2)
                        const grB1_pixel = Convert.toPixel(obj.rB1)
                        const grB2_pixel = Convert.toPixel(obj.rB2)

                        obj.points = [obj.rA1,obj.rA2,obj.rB2,obj.rB1]


                        ctx.fillStyle = '#009ee3'
                        ctx.strokeStyle = '#fff'


                        ctx.beginPath()
                        ctx.moveTo(grA1_pixel.x,grA1_pixel.y)
                        ctx.lineTo(grA2_pixel.x,grA2_pixel.y)
                        ctx.lineTo(grB2_pixel.x,grB2_pixel.y)
                        ctx.lineTo(grB1_pixel.x,grB1_pixel.y)
                        ctx.moveTo(grA1_pixel.x,grA1_pixel.y)
                        ctx.closePath()
                        ctx.fill()
                        ctx.stroke()


                        if (obj.isWindow) {
                            const __v3 = objV.clone().rotateAround(new Vector2(0,0), 90*(Math.PI/180)).setLength(halfH/3)
                            obj.rA11 = {x:__v3.x+objA.x,y:__v3.y+objA.y}
                            obj.rB11 = {x:__v3.x+objB.x,y:__v3.y+objB.y}

                            const __v4 = objV.clone().rotateAround(new Vector2(0,0), -90*(Math.PI/180)).setLength(halfH/3)
                            obj.rA22 = {x:__v4.x+objA.x,y:__v4.y+objA.y}
                            obj.rB22 = {x:__v4.x+objB.x,y:__v4.y+objB.y}

                            const grA11_pixel = Convert.toPixel(obj.rA11)
                            const grA22_pixel = Convert.toPixel(obj.rA22)
                            const grB11_pixel = Convert.toPixel(obj.rB11)
                            const grB22_pixel = Convert.toPixel(obj.rB22)

                            ctx.beginPath()
                            ctx.moveTo(grA11_pixel.x,grA11_pixel.y)
                            ctx.lineTo(grB11_pixel.x,grB11_pixel.y)
                            ctx.closePath()
                            ctx.stroke()

                            ctx.beginPath()
                            ctx.moveTo(grA22_pixel.x,grA22_pixel.y)
                            ctx.lineTo(grB22_pixel.x,grB22_pixel.y)
                            ctx.closePath()
                            ctx.stroke()
                        }
                    }
                })
            })
        }
/////////////////////////////////////////////////////////////////////////////////////
        const drawSize = (plan,wall) => {

            let length1 = (Math.ceil((new Vector2(wall.rA1.x,wall.rA1.y))
                .distanceTo(new Vector2(wall.rA2.x,wall.rA2.y)))).toString() + ' '+getStrLang('c3d_6SHYr')
            let length2 = (Math.ceil((new Vector2(wall.rB1.x,wall.rB1.y))
                .distanceTo(new Vector2(wall.rB2.x,wall.rB2.y)))).toString() + ' '+getStrLang('c3d_6SHYr')
            const ln = Math.abs(wall.a.clone().sub(wall.b).length());
            const tw1 = ctx.measureText(length1).width+8;
            const tw2 = ctx.measureText(length2).width+8;

            if(ln*zoom>tw1+30) {
                const _a = Convert.toPixel(wall.rA1);
                const _b = Convert.toPixel(wall.rA2);
                const v = _b.clone().sub(_a); //вектор стены
                const c = _b.clone().add(_a).multiplyScalar(0.5); //центр в рихелях
                const a = v.angle(); //угол поворота в rad относительно ------------> (x)filll
                const len = v.length();
                // const halfH = wall.h * zoom / 2
                const halfH = 0
                ctx.translate(c.x, c.y);
                ctx.rotate(a);
                // ctx.strokeStyle = '#5A5A5A';
                // ctx.beginPath();
                // ctx.moveTo(-len / 2, -halfH);
                // ctx.lineTo(-len / 2, -halfH - 25);
                // ctx.moveTo(-len / 2, -halfH - 20);
                // ctx.lineTo(-len / 2 + 9, -halfH - 22);
                // ctx.lineTo(-len / 2 + 9, -halfH - 18);
                // ctx.lineTo(-len / 2, -halfH - 20);
                //
                // ctx.moveTo(len / 2, -halfH);
                // ctx.lineTo(len / 2, -halfH - 25);
                // ctx.moveTo(len / 2, -halfH - 20);
                // ctx.lineTo(len / 2 - 9, -halfH - 22);
                // ctx.lineTo(len / 2 - 9, -halfH - 18);
                // ctx.lineTo(len / 2, -halfH - 20);
                //
                // ctx.moveTo(-len / 2, -halfH - 20);
                // ctx.lineTo(len / 2, -halfH - 20);
                // ctx.stroke();

                ctx.translate(0, -8 - halfH);
                // ctx.strokeStyle = ctx.fillStyle = '#868786';
                ctx.strokeStyle = ctx.fillStyle = '#6E6E6E'
                if(hoverObject === wall || activeObject === wall){
                    ctx.strokeStyle = ctx.fillStyle = '#009ee3';
                }
                ctx.fillRect(-tw1 / 2, -8, tw1, 16);
                ctx.strokeRect(-tw1 / 2, -8, tw1, 16);
                if(a>Math.PI/2 && a<3*Math.PI/2) ctx.rotate(Math.PI);
                ctx.fillStyle = '#FFFFFF';
                ctx.fillText(length1, 0, 0);
                if(a>Math.PI/2 && a<3*Math.PI/2) ctx.rotate(-Math.PI);
                ctx.translate(0, 8 + halfH);

                ctx.rotate(-a);
                ctx.translate(-c.x, -c.y);
            }
            if(ln*zoom>tw2+30) {
                const _a = Convert.toPixel(wall.rB1);
                const _b = Convert.toPixel(wall.rB2);
                const v = _b.clone().sub(_a); //вектор стены
                const c = _b.clone().add(_a).multiplyScalar(0.5); //центр в рихелях
                const a = v.angle(); //угол поворота в rad относительно ------------> (x)filll
                const len = v.length();
                // const halfH = wall.h * zoom / 2
                const halfH = 0
                ctx.translate(c.x, c.y);
                ctx.rotate(a);
                // ctx.strokeStyle = '#5A5A5A';
                // ctx.beginPath();
                // ctx.moveTo(-len / 2, -halfH);
                // ctx.lineTo(-len / 2, -halfH - 25);
                // ctx.moveTo(-len / 2, -halfH - 20);
                // ctx.lineTo(-len / 2 + 9, -halfH - 22);
                // ctx.lineTo(-len / 2 + 9, -halfH - 18);
                // ctx.lineTo(-len / 2, -halfH - 20);
                //
                // ctx.moveTo(len / 2, -halfH);
                // ctx.lineTo(len / 2, -halfH - 25);
                // ctx.moveTo(len / 2, -halfH - 20);
                // ctx.lineTo(len / 2 - 9, -halfH - 22);
                // ctx.lineTo(len / 2 - 9, -halfH - 18);
                // ctx.lineTo(len / 2, -halfH - 20);
                //
                // ctx.moveTo(-len / 2, -halfH - 20);
                // ctx.lineTo(len / 2, -halfH - 20);
                // ctx.stroke();

                ctx.translate(0, 8 + halfH);
                // ctx.strokeStyle = ctx.fillStyle = '#868786';
                ctx.strokeStyle = ctx.fillStyle = '#6E6E6E'
                if(hoverObject === wall || activeObject === wall){
                    ctx.strokeStyle = ctx.fillStyle = '#009ee3';
                }
                ctx.fillRect(-tw2 / 2, -8, tw2, 16);
                ctx.strokeRect(-tw2 / 2, -8, tw2, 16);
                if(a>Math.PI/2 && a<3*Math.PI/2) ctx.rotate(Math.PI);
                ctx.fillStyle = '#FFFFFF';
                ctx.fillText(length2, 0, 0);
                if(a>Math.PI/2 && a<3*Math.PI/2) ctx.rotate(-Math.PI);
                ctx.translate(0, -8 - halfH);

                ctx.rotate(-a);
                ctx.translate(-c.x, -c.y);
            }
        };
//////////////////////////////////////////////////////////////////////////////
        const drawNode = (plan,n)=>{
            const vectors = plan.links.reduce((acc,l)=>{
                if(l.a === n) acc.push({v:new Vector2(l.b.x-n.x,l.b.y-n.y).normalize(),h:l.h});
                else if(l.b === n) acc.push({v:new Vector2(l.a.x-n.x,l.a.y-n.y).normalize(),h:l.h});
                return acc;
            },[]);
            if(plan.virtualLink){
                if(plan.virtualLink.a === n) vectors.push({v:new Vector2(plan.virtualLink.b.y-n.x,plan.virtualLink.b.y-n.y).normalize(),h:plan.virtualLink.h});
                else if(plan.virtualLink.b === n) vectors.push({v:new Vector2(plan.virtualLink.a.y-n.x,plan.virtualLink.a.y-n.y).normalize(),h:plan.virtualLink.h});
            }
            const _n = Convert.toPixel(n);

            ctx.fillStyle = '#ffffff'
            // ctx.fillStyle = 'rgba(255,255,255,0.2)'
            // ctx.strokeLinecap = 'round'
            ctx.strokeStyle = '#000000'


            if(activeObject && n === activeObject.object) {
                ctx.fillStyle = '#009ee3'
                ctx.strokeStyle = '#0874a3'
            }

            ctx.beginPath()
            const r = n===plan.hoverNode?14:9;  //9px радиус круга, 14px при hover

            ctx.arc(_n.x, _n.y, r, 0, 2 * Math.PI);
            ctx.fill();
            ctx.stroke();

            // if (window.debug) {
            //     ctx.fillStyle = '#000';
            //     ctx.fillText(plan.nodes.findIndex(node => node === n).toString(), _n.x, _n.y);
            // }

            if(vectors.length>1){
                const sortVectors = vectors.sort((a,b)=>{
                    if(a.v.angle()<b.v.angle()) return 1;
                    if(a.v.angle()>b.v.angle()) return -1;
                    return 0
                });
                ctx.fillStyle = '#333333';
                ctx.strokeStyle = '#333333';
                for(let i=0;i<sortVectors.length;i++){
                    let v1,v2;
                    if(i===sortVectors.length-1){
                        v1=sortVectors[i];
                        v2=sortVectors[0];
                    }
                    else{
                        v1=sortVectors[i];
                        v2=sortVectors[i+1];
                    }
    //console.log("TWO VECTORS", v1, v2);
                    /*
                    const v = new Vector2(1,0).rotateAround(new Vector2(0,0),v1.v.angle()+(v2.v.angle()-v1.v.angle())/2).normalize();
                    const d=Math.sqrt(v1.h/2*v1.h/2+v2.h/2*v2.h/2+v1.h/2*v2.h/2*Math.cos(Math.PI - v2.v.angle()-v1.v.angle()));
                    ctx.strokeStyle = '#FF0000';
                    ctx.beginPath();
                    ctx.moveTo(_n.x,_n.y);
                    ctx.lineTo(_n.x+v.x*(d+0),_n.y+v.y*(d+0));
                    ctx.stroke();
                    */
                    //ctx.fillText(Math.round(Math.abs(v1.clone().sub(v2).angle()*180/Math.PI)),_n.x+40*v.x*zoom,_n.y+40*v.y*zoom);
                }
            }
            //console.log("DRAW NODE",n,vectors,sortVectors);

        };
////////////////////////////////////////////////////////////////////////////
        const drawModule = (module)=>{
            const pos = Convert.toPixel(new Vector2(module.position.x,module.position.y));
            ctx.translate(pos.x,pos.y);
            ctx.rotate(-module.angle);
            // ctx.scale(zoom,zoom);
            const moduleImage = (module===hoverObject)?module.shema.hover:module.shema.normal
            // console.log('ratio',ratio)
            const imageW = (moduleImage.width/2*zoom)
            const imageH = (moduleImage.height/2*zoom)
            let moduleX, moduleY
            // moduleX = ((-module.size.pivot.x/ratio*zoom) + (module.size.width/2/ratio*zoom) - imageW/2)
            // moduleY = ((-module.size.pivot.y/ratio*zoom) + (module.size.height/2/ratio*zoom) - imageH/2)
            moduleX = (-module.size.pivot.x)*zoom + (module.size.width/2*zoom) - imageW/2
            moduleY = (-module.size.pivot.y)*zoom + (module.size.height/2*zoom) - imageH/2
            // if (module._optionStatus)
            //     moduleY = ((-module.size.pivot.y) + (module.size.height/2) - imageH/2) - (41)

            if (window.debug) {
                ctx.fillStyle = '#67889720'
                ctx.fillRect(moduleX, moduleY, imageW, imageH)
            }
            ctx.drawImage(
                moduleImage, moduleX, moduleY, imageW, imageH,
            )

            // console.log('ratio',ratio)
            // console.log('drawModule():module',module)
            // console.log('moduleImage.width, moduleImage.height',moduleImage.width, moduleImage.height)

            if(activeObject===module){

                // ctx.scale(1/zoom,1/zoom);

                ctx.strokeStyle = '#ff2a2a';
                ctx.fillStyle = '#ff2a2a'
                ctx.beginPath();
                ctx.arc((module.size.pivot.x-module.size.width-10)*zoom, (module.size.pivot.y-module.size.height-10)*zoom, 5, 0, Math.PI*2);
                // ctx.arc((-module.size.pivot.x-10)*zoom, (-module.size.pivot.y-10)*zoom, 5, 0, Math.PI*2)
                ctx.fill();
                ctx.stroke();

                //периметр
                ctx.beginPath();
                ctx.strokeStyle = '#555555';
                ctx.fillStyle = '#555555'
                ctx.moveTo((-module.size.pivot.x)*zoom, (-module.size.pivot.y)*zoom);
                ctx.lineTo((module.size.width-module.size.pivot.x)*zoom, (-module.size.pivot.y)*zoom);
                ctx.lineTo((module.size.width-module.size.pivot.x)*zoom, (module.size.height-module.size.pivot.y)*zoom);
                ctx.lineTo((-module.size.pivot.x)*zoom, (module.size.height-module.size.pivot.y)*zoom);
                ctx.closePath();
                ctx.stroke();

                ctx.strokeStyle = ctx.fillStyle = '#009ee380'
                ctx.lineWidth = 16*zoom
                ctx.beginPath();
                ctx.moveTo((-module.size.pivot.x)*zoom-(8*zoom), (-module.size.pivot.y)*zoom-(8*zoom));
                ctx.lineTo((module.size.width-module.size.pivot.x)*zoom+(8*zoom), (-module.size.pivot.y)*zoom-(8*zoom));
                ctx.lineTo((module.size.width-module.size.pivot.x)*zoom+(8*zoom), (module.size.height-module.size.pivot.y)*zoom+(8*zoom));
                ctx.lineTo((-module.size.pivot.x)*zoom-(8*zoom), (module.size.height-module.size.pivot.y)*zoom+(8*zoom));
                ctx.closePath();
                ctx.stroke();
                ctx.lineWidth = 1

                //дистанции
                let d; //дистанция
                let origin = new Vector2(); // источник луча
                let direction = new Vector2(); // направление луча
                const zeroVector = new Vector2(0, 0);
                let w = module.size.width;
                let h = module.size.height;
                let pivot = module.size.pivot;
                let mod = module.model;
                let angle = module.angle;
                // верх
                ctx.fillStyle = ctx.strokeStyle = "#868786";
                //ctx.fillStyle = ctx.strokeStyle = "#FF0000";
                d = Infinity;
                origin.x = 0;
                origin.y = -pivot.y;
                origin.rotateAround(zeroVector, -angle);
                origin.add(new Vector2(module.position.x, module.position.y));
                direction.x = 0;
                direction.y = -1;
                direction.rotateAround(zeroVector, -angle);

                plan.links.map(w => {
                    let _d = distanceRayToLink(origin, direction, w);
                    if (_d < d) d = _d;
                });

                props.modules.map(m => {
                    if(m!==module){
                        let _d = distanceRayToModule(origin, direction, m);
                        if (_d < d) d = _d;
                    }
                });

                if (d !== Infinity  && d>0) {
                    d = Math.round(d);
                    //const center = Convert.toPixel(origin.clone().add(direction.clone().multiplyScalar(d*zoom/2)));
                    const tw = ctx.measureText(d.toString()).width+8;
                    ctx.translate(0,(-d/2-pivot.y)*zoom);
                    ctx.rotate(-Math.PI/2);
                    ctx.beginPath();
                    ctx.moveTo(-d*zoom/2,0);
                    ctx.lineTo(d*zoom/2,0);
                    ctx.stroke();
                    //ctx.beginPath();
                    ctx.fillRect(-tw / 2, -8, tw, 16);
                    ctx.strokeStyle = "#FFFFFF";
                    ctx.fillStyle = "#FFFFFF";
                    ctx.fillText(d, 0, 0);
                    //ctx.fill();
                    //ctx.stroke();
                    ctx.rotate(Math.PI/2);
                    ctx.translate(0,(d/2+pivot.y)*zoom);
                }
                // низ
                ctx.strokeStyle = "#868786";
                ctx.fillStyle = "#868786";
                d = Infinity;
                origin.x = 0;
                origin.y = h-pivot.y;
                origin.rotateAround(zeroVector, -angle);
                origin.add(new Vector2(module.position.x, module.position.y));
                direction.x = 0;
                direction.y = 1;
                direction.rotateAround(zeroVector, -angle);

                plan.links.map(w => {
                    let _d = distanceRayToLink(origin, direction, w);
                    if (_d < d) d = _d;
                });
                props.modules.map(m => {
                    if(m!==module){
                        let _d = distanceRayToModule(origin, direction, m);
                        if (_d < d) d = _d;
                    }
                });
                if (d !== Infinity  && d>0) {
                    d = Math.round(d);
                    const tw = ctx.measureText(d.toString()).width+8;
                    ctx.translate(0,(d/2+h-pivot.y)*zoom);
                    ctx.rotate(-Math.PI/2);
                    ctx.beginPath();
                    ctx.moveTo(-d*zoom/2,0);
                    ctx.lineTo(d*zoom/2,0);
                    ctx.stroke();
                    ctx.fillRect(-tw / 2, -8, tw, 16);
                    ctx.strokeStyle = "#FFFFFF";
                    ctx.fillStyle = "#FFFFFF";
                    ctx.fillText(d, 0, 0);
                    ctx.rotate(Math.PI/2);
                    ctx.translate(0,(-d/2-h+pivot.y)*zoom);
                }
                // лево
                ctx.strokeStyle = "#868786";
                ctx.fillStyle = "#868786";
                d = Infinity;
                origin.x = -pivot.x;
                origin.y = 0;
                origin.rotateAround(zeroVector, -angle);
                origin.add(new Vector2(module.position.x, module.position.y));
                direction.x = -1;
                direction.y = 0;
                direction.rotateAround(zeroVector, -angle);

                plan.links.map(w => {
                    let _d = distanceRayToLink(origin, direction, w);
                    if (_d < d) d = _d;
                });
                props.modules.map(m => {
                    if(m!==module){
                        let _d = distanceRayToModule(origin, direction, m);
                        if (_d < d) d = _d;
                    }
                });
                if (d !== Infinity  && d>0) {
                    d = Math.round(d);
                    const tw = ctx.measureText(d.toString()).width+8;
                    ctx.translate((-d/2-pivot.x)*zoom,0);
                    ctx.beginPath();
                    ctx.moveTo(-d*zoom/2,0);
                    ctx.lineTo(d*zoom/2,0);
                    ctx.stroke();
                    ctx.fillRect(-tw / 2, -8, tw, 16);
                    ctx.strokeStyle = "#FFFFFF";
                    ctx.fillStyle = "#FFFFFF";
                    ctx.fillText(d, 0, 0);
                    ctx.translate((d/2+pivot.x)*zoom,0);
                }
                // право
                ctx.strokeStyle = "#868786";
                ctx.fillStyle = "#868786";
                d = Infinity;
                origin.x = w-pivot.x;
                origin.y = 0;
                origin.rotateAround(zeroVector, -angle);
                origin.add(new Vector2(module.position.x, module.position.y));
                direction.x = 1;
                direction.y = 0;
                direction.rotateAround(zeroVector, -angle);

                plan.links.map(w => {
                    let _d = distanceRayToLink(origin, direction, w);
                    if (_d < d) d = _d;
                });
                props.modules.map(m => {
                    if(m!==module){
                        let _d = distanceRayToModule(origin, direction, m);
                        if (_d < d) d = _d;
                    }
                });
                if (d !== Infinity && d>0) {
                    d = Math.round(d);
                    const tw = ctx.measureText(d.toString()).width+8;
                    ctx.translate((d/2+w-pivot.x)*zoom,0);
                    ctx.beginPath();
                    ctx.moveTo(-d*zoom/2,0);
                    ctx.lineTo(d*zoom/2,0);
                    ctx.stroke();
                    ctx.fillRect(-tw / 2, -8, tw, 16);
                    ctx.strokeStyle = "#FFFFFF";
                    ctx.fillStyle = "#FFFFFF";
                    ctx.fillText(d, 0, 0);
                    ctx.translate((-d/2-w+pivot.x)*zoom,0);
                }
            }
            // else ctx.scale(1/zoom,1/zoom);
            ctx.rotate(module.angle);
            ctx.translate(-pos.x,-pos.y);

        }
//////////////////////////////////////////////////////////////////////////////
        const distanceRayToModule = (origin, direction, m)=>{

            const p1 = m.position.clone().add(new Vector2(-m.size.pivot.x,-m.size.pivot.y));//.rotateAround(m.position,-m.angle);
            const p2 = m.position.clone().add(new Vector2(m.size.width-m.size.pivot.x,-m.size.pivot.y));//.rotateAround(m.position,-m.angle);
            const p3 = m.position.clone().add(new Vector2(m.size.width-m.size.pivot.x,m.size.height-m.size.pivot.y));//.rotateAround(m.position,-m.angle);
            const p4 = m.position.clone().add(new Vector2(-m.size.pivot.x,m.size.height-m.size.pivot.y));//.rotateAround(m.position,-m.angle);
            let d = Infinity;

            const dist = (origin,direction,a,b)=>{
                const a1 = -direction.y;
                const b1 = direction.x;
                const c1 = origin.x*(origin.y+direction.y) - (origin.x+direction.x)*origin.y;

                const a2 = a.y - b.y;
                const b2 = b.x - a.x;
                const c2 = a.x*b.y - b.x*a.y;

                const det = (a,b,c,d)=>a * d - b * c;

                const zn = det(a1,b1,a2,b2)

                if (Math.abs(zn) < 0.0000001) return Infinity;
                else{
                    const v = new Vector2(
                        - det (c1, b1, c2, b2) / zn,
                        - det (a1, c1, a2, c2) / zn
                    );
                    //проверяем сторону луча
                    if(v.clone().sub(origin).dot(direction)<0) return Infinity;
                    //проверяем что точка на отрезке
                    if(a.x<b.x && (v.x<a.x || v.x>b.x)) return Infinity;
                    if(a.x>b.x && (v.x>a.x || v.x<b.x)) return Infinity;
                    if(a.x===b.x && a.y<b.y && (v.y<a.y || v.y>b.y)) return Infinity;
                    if(a.x===b.x && a.y>b.y && (v.y>a.y || v.y<b.y)) return Infinity;
                    return v.sub(origin).length();
                }
            }
            let _d = dist(origin,direction,p1,p2);
            if(_d<d) d=_d;
            _d = dist(origin,direction,p2,p3);
            if(_d<d) d=_d;
            _d = dist(origin,direction,p3,p4);
            if(_d<d) d=_d;
            _d = dist(origin,direction,p4,p1);
            if(_d<d) d=_d;

            return d;
        }
//////////////////////////////////////////////////////////////////////////////
        const distanceRayToLink = (origin, direction, w)=>{
            const a1 = -direction.y;
            const b1 = direction.x;
            const c1 = origin.x*(origin.y+direction.y) - (origin.x+direction.x)*origin.y;

            const a2 = w.a.y - w.b.y;
            const b2 = w.b.x - w.a.x;
            const c2 = w.a.x*w.b.y - w.b.x*w.a.y;

            const det = (a,b,c,d)=>a * d - b * c;

            const zn = det(a1,b1,a2,b2)

            if (Math.abs(zn) < 0.0000001) return Infinity;
            else{
                const v = new Vector2(
                    - det (c1, b1, c2, b2) / zn,
                    - det (a1, c1, a2, c2) / zn
                );
                //проверяем сторону луча
                if(v.clone().sub(origin).dot(direction)<0) return Infinity;
                //проверяем что точка на отрезке
                if(w.a.x<w.b.x && (v.x<w.a.x || v.x>w.b.x)) return Infinity;
                if(w.a.x>w.b.x && (v.x>w.a.x || v.x<w.b.x)) return Infinity;
                if(w.a.x===w.b.x && w.a.y<w.b.y && (v.y<w.a.y || v.y>w.b.y)) return Infinity;
                if(w.a.x===w.b.x && w.a.y>w.b.y && (v.y>w.a.y || v.y<w.b.y)) return Infinity;
                return v.sub(origin).length()-Math.abs(w.h/2);
            }
        }
////////////////////////////////////////////////////////////////////////////
        const getAngle = l=>{
            let angle = Math.atan2(l.a.y-l.b.y, l.b.x-l.a.x );
            if(angle>Math.PI*2) angle-=Math.PI*2;
            else if(angle<0) angle+=Math.PI*2;
            return angle;
        };
/////////////////////////////////////////////////////////////////////////////
        const distNodeToLink = (n,l)=>{
            const v = [l.b.x-l.a.x,l.b.y-l.a.y];
            const w = [n.x-l.a.x,n.y-l.a.y];

            const c1 = v[0]*w[0]+v[1]*w[1];
            if(c1<=0) return distNodeToNode(n,l.a);

            const c2 = v[0]*v[0]+v[1]*v[1];
            if(c2<=c1) return distNodeToNode(n,l.b);

            return Math.abs(((l.a.y - l.b.y)*n.x+(l.b.x-l.a.x)*n.y+(l.a.x*l.b.y-l.b.x*l.a.y))/
                Math.sqrt((l.b.x-l.a.x)*(l.b.x-l.a.x)+(l.b.y-l.a.y)*(l.b.y-l.a.y)));
        };
/////////////////////////////////////////////////////////////////////////
        const distNodeToNode = (n1,n2)=>{
            return Math.sqrt((n1.x-n2.x)*(n1.x-n2.x)+(n1.y-n2.y)*(n1.y-n2.y));
        };
/////////////////////////////////////////////////////////////////
        /*
        Растояние в см до ближайшей ноды
        point - Node(координата)
        nodes - массив Node
        exNode - исключающий массив Node
        return [dist,node] растояние см, Node из массива nodes или [Infinity,null]
         */
        const getNearestDistToNode = (point,nodes,exNodes = [])=>{
            return nodes.reduce((res,n)=>{
                if(!exNodes.find(exn=>exn===n)){
                    const _d = distNodeToNode(point, n);
                    return _d<res[0]?[_d,n]:res;
                }
                else return res;
            },[Infinity,null])
        };
/////////////////////////////////////////////////////////////////
        /*
         Растояние в см до ближайшей стены
         point - Node(координата)
         links - массив стен(Link)
         exNode - исключающий массив стен(Link)
         return [dist,link] растояние см, Link из массива links или [Infinity,null]
         */
        const getNearestDistToLink = (point,links,exLinks = [])=>{
            return links.reduce((res,l)=>{
                if(!exLinks.find(exl=>exl===l)){
                    const _d = distNodeToLink(point, l);
                    return _d<res[0]?[_d,l]:res;
                }
                else return res;
            },[Infinity,null])
        };
/////////////////////////////////////////////////////////////////////////
        const Convert = {
            toPixel: (p)=>{    //на вход вестор в см на выход в px
                const x = Math.ceil(ctx.width/2+p.x*zoom-offsetX)
                const y = Math.ceil(ctx.height/2+p.y*zoom-offsetY)
                return new Node(x,y)
            },
            toSM:(p)=>{     //на вход вестор в px на выход в см
                const x = Math.ceil((p.x-ctx.width/2+offsetX)/zoom)
                const y = Math.ceil((-ctx.height/2+p.y+offsetY)/zoom)
                return new Node(x,y)
            },
            getCanvasCenterPixel: ()=>{
                const x = Math.ceil((ctx.width-(ctx.width/2))/ratio)
                const y = Math.ceil((ctx.height-(ctx.height/2))/ratio)
                return new Node(x,y)
            }
        }
////////////////////////////////////////////////////////////////////////
        if (is_touch_device()) {
            // canvas.unselectable = "on";
            // canvas.addEventListener('mousedown',handlerDown);
            canvas.addEventListener('touchstart',handlerDown);
            // canvas.addEventListener('mouseup',handlerUp);
            canvas.addEventListener('touchend',handlerUp);
            canvas.addEventListener('touchmove',handlerMove);
            canvas.addEventListener('touchcancel',handlerOut);

            canvas.addEventListener('wheel',handlerWheel);
            // canvas.addEventListener('onselectstart',handlerOnselectstart);
            canvas.addEventListener('contextmenu', handlerContext, false);
            canvas.addEventListener('redraw', handlerRedraw, false);
            canvas.addEventListener('redrawSimple', handlerRedrawSimple, false);
            canvas.addEventListener('unselect', handlerUnselect, false);
            canvas.addEventListener('reselect', handlerReselect, false);
            window.addEventListener('resize', handlerResize, false);
        } else {
            canvas.addEventListener('mousedown',handlerDown);
            canvas.addEventListener('mouseup',handlerUp);
            canvas.addEventListener('mousemove',handlerMove);
            canvas.addEventListener('mouseout',handlerOut);
            canvas.addEventListener('wheel',handlerWheel);
            canvas.addEventListener('contextmenu', handlerContext, false);
            canvas.addEventListener('redraw', handlerRedraw, false);
            canvas.addEventListener('redrawSimple', handlerRedrawSimple, false);
            canvas.addEventListener('unselect', handlerUnselect, false);
            canvas.addEventListener('reselect', handlerReselect, false);
            window.addEventListener('resize', handlerResize, false);
            window.addEventListener('keydown',handlerKeydown, false);
        }


/*
        canvas.addEventListener("touchstart", function (e) {
            const mousePos = getTouchPos(canvas, e);
            const touch = e.touches[0];
            const mouseEvent = new MouseEvent("mousedown", {
                clientX: touch.clientX,
                clientY: touch.clientY
            });
            canvas.dispatchEvent(mouseEvent);
        }, false);
        canvas.addEventListener("touchend", function (e) {
            const mouseEvent = new MouseEvent("mouseup", {});
            canvas.dispatchEvent(mouseEvent);
        }, false);
        canvas.addEventListener("touchmove", function (e) {
            const touch = e.touches[0];
            const mouseEvent = new MouseEvent("mousemove", {
                clientX: touch.clientX,
                clientY: touch.clientY
            });
            canvas.dispatchEvent(mouseEvent);
        }, false);
        function getTouchPos(canvasDom, touchEvent) {
            const rect = canvasDom.getBoundingClientRect();
            return {
                x: touchEvent.touches[0].clientX - rect.left,
                y: touchEvent.touches[0].clientY - rect.top
            };
        }*/
        // Prevent scrolling when touching the canvas
        /*document.body.addEventListener("touchstart", function (e) {
            if (e.target == canvas) {
                e.preventDefault();
            }
        }, false);
        document.body.addEventListener("touchend", function (e) {
            if (e.target == canvas) {
                e.preventDefault();
            }
        }, false);
        document.body.addEventListener("touchmove", function (e) {
            if (e.target == canvas) {
                e.preventDefault();
            }
        }, false);*/

        // const animate = ()=> {
        //     requestAnimationFrame(animate);
            draw(ctx,plan);
        // }
        // animate();


        if (plan.restored) {
            dispatch(ProjectState.setEditMode(false))
            plan.restored = false
        } else {
            plan.canvasCenter = Convert.toSM(Convert.getCanvasCenterPixel())
        }

        return ()=>{
            if (is_touch_device()) {
                // canvas.removeEventListener('mousedown',handlerDown);
                canvas.removeEventListener('touchstart',handlerDown); //
                // canvas.removeEventListener('mouseup',handlerUp);
                canvas.removeEventListener('touchend',handlerUp); //
                // canvas.removeEventListener('mousemove',handlerMove);
                canvas.removeEventListener('touchmove',handlerMove); //
                canvas.removeEventListener('touchcancel',handlerOut); //
                canvas.removeEventListener('wheel',handlerWheel);
                // canvas.removeEventListener('onselectstart',handlerOnselectstart);
                canvas.removeEventListener('contextmenu', handlerContext, false);
                canvas.removeEventListener('redraw', handlerRedraw, false);
                canvas.removeEventListener('redrawSimple', handlerRedrawSimple, false);
                canvas.removeEventListener('unselect', handlerUnselect, false);
                canvas.removeEventListener('reselect', handlerReselect, false);
                window.removeEventListener('resize', handlerResize, false);
            } else {
                canvas.removeEventListener('mousedown',handlerDown);
                canvas.removeEventListener('mouseup',handlerUp);
                canvas.removeEventListener('mousemove',handlerMove);
                canvas.removeEventListener('mouseout',handlerOut);
                canvas.removeEventListener('wheel',handlerWheel);
                canvas.removeEventListener('contextmenu', handlerContext, false);
                canvas.removeEventListener('redraw', handlerRedraw, false);
                canvas.removeEventListener('redrawSimple', handlerRedrawSimple, false);
                canvas.removeEventListener('unselect', handlerUnselect, false);
                canvas.removeEventListener('reselect', handlerReselect, false);
                window.removeEventListener('resize', handlerResize, false);
                window.removeEventListener('keydown',handlerKeydown, false);
            }
        }
    },[props.modules,props.editMode,props.plan]);

    useEffect(()=>{
        if(props.plan.nodes.length===0 && !props.editMode) {
            dispatch(ProjectState.setEditMode(true));
            setActiveObject(null)
        }
        if(props.plan.loop.length>0 && props.editMode) dispatch(ProjectState.setEditMode(false));
        return ()=>{
            //dispatch(ProjectState.setPlan(props.plan));
        }
    },[props.plan]);
    const modal = useSelector(store=>store.project.modal);

    const removeWall = (wall)=>{
        props.plan.removeWall(wall);
        sendRedrawEvent(ref.current);
        setActiveObject(null);
    }

    const cutWall = (wall)=>{
        props.plan.cutWall(wall);
        sendRedrawEvent(ref.current);
        setActiveObject(null)
    }

    const modules = useSelector(store=>store.modules.modules);

    const changeModule = (module,variant)=>{
        index = modules.indexOf(module);
        dispatch({type:'CHANGE_MODULE',module,variant});
    }
    useEffect(()=>{
        if(index!==null) {
            setActiveObject({point:{},object:modules[index]});
            index = null;
        }
    },[updateFlag]);

    return <>
        <canvas id="plan" ref={ref}></canvas>
        {/*<canvas id="planFake" ref={reffake}></canvas>*/}
        {/*<canvas id="planFake2" ref={reffake2}></canvas>*/}
        <OrderMenu/>
        {activeObject!==null && activeObject.object.isModule &&
            <ModuleMenu
                position={activeObject.point}
                module={activeObject.object}
            />
        }
        {activeObject!==null && activeObject.object.isLink &&
        <WallMenu
            position={activeObject.point}
            wall={activeObject.object}
            remove={removeWall}
            cutWall={cutWall}
        />
        }
        {activeObject!==null && activeObject.object.wall && activeObject.object.obj>-1 &&
        <WallObjectMenu
            position={activeObject.point}
            wall={activeObject.object.wall}
            objIndex={activeObject.object.obj}
        />}
        {activeObject!==null && activeObject.object.floor > -1 &&
        <FloorMenu
            position={activeObject.point}
            floor={activeObject.object}
        />
        }
        {modal === 'WallObjectInfo' && activeObject!==null && activeObject.object.wall && activeObject.object.obj>-1 &&
        <WallObjectInfo
            position={activeObject.point}
            wall={activeObject.object.wall}
            objIndex={activeObject.object.obj}
        />
        }
        {modal === 'modules' && <Modules/>}
        {modal === 'projects' && <Projects/>}
        {modal === 'materials' && <Materials/>}
        {modal === 'moduleInfo' && activeObject.object.isModule &&
            <ModuleInfo
                module={activeObject.object}
                changeModule={changeModule}
            />
        }
        {modal === 'wallInfo' && activeObject.object.isLink &&
        <WallInfo
            wall={activeObject.object}
        />
        }
        {modal === 'floorInfo' && activeObject.object.floor > -1 &&
        <FloorInfo
            floor={activeObject.object}
        />
        }
        {modal === 'save' &&
        <SaveInfo/>
        }
        {modal === 'modulesList' &&
        <ModulesList/>
        }
        </>
}

const mapStateToProps = state => (
    {
        modules: state.modules.modules,
        editMode: state.project.editMode
    }
)

export default connect(mapStateToProps)(PlanEditor);
